import type { FileItem } from '../../doc/schema';

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

/** Attachment chip: extension badge, name, size. Double-click downloads (see useGestures). */
export function FileBody({ item }: { item: FileItem }) {
  const { name, size } = item.props;
  const ext = (name.includes('.') ? name.split('.').pop()! : 'file').toUpperCase().slice(0, 5);
  return (
    <div className="file-chip" title={name}>
      <span className="file-ext">{ext}</span>
      <span className="file-meta">
        <span className="file-name">{name}</span>
        <span className="file-size">{formatBytes(size)}</span>
      </span>
    </div>
  );
}
